module.exports = __webpack_public_path__ + "static/media/Loan.b4bb01df.svg";